import { Database } from '../../types/supabase'
import { createBrowserClient } from '@supabase/ssr'
import { publicEnv } from '@/constants/publicEnv.ts'

export const createSupabaseBrowserClient = () => {
  // this returns a singleton client
  return createBrowserClient<Database>(
    publicEnv.EXPO_PUBLIC_SUPABASE_URL,
    publicEnv.EXPO_PUBLIC_SUPABASE_ANON_KEY,
    {
      auth: {
        // for OTP this doesn't matter, but some verification emails may contain the code
        flowType: 'pkce',
      },
    },
  )
}
